module.exports = __webpack_public_path__ + "static/img/logo.f19b05f9.svg";